// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "ReportPage-module--hgwIcon-arrow-down--3IcRe";
export var hgwIconArrowUp = "ReportPage-module--hgwIcon-arrow-up--1Hweu";
export var singleSection = "ReportPage-module--singleSection--3SEVl";
export var singleSection__pager = "ReportPage-module--singleSection__pager--Qq_w5";
export var singleImageBox = "ReportPage-module--singleImageBox--22GhA";
export var singleImageBox__pins = "ReportPage-module--singleImageBox__pins--PnZRu";
export var buttonImage = "ReportPage-module--buttonImage--26z0d";
export var temmetsu = "ReportPage-module--temmetsu--1R0y_";
export var singleModal = "ReportPage-module--singleModal--1NKqR";
export var htmlTextBox = "ReportPage-module--htmlTextBox--12RGg";
export var mediaModal = "ReportPage-module--mediaModal--mp3-q";
export var mediaModal__close = "ReportPage-module--mediaModal__close--3nHCs";
export var mediaModal__video = "ReportPage-module--mediaModal__video--2OFY8";
export var mediaModal__imageBox = "ReportPage-module--mediaModal__imageBox--XfssW";
export var attachmentWrap = "ReportPage-module--attachmentWrap--2radC";
export var attachmentWrap__items = "ReportPage-module--attachmentWrap__items--3u6cj";
export var attachment = "ReportPage-module--attachment--2lXPc";
export var redFilter = "ReportPage-module--redFilter--1_v-C";
export var isVisible = "ReportPage-module--isVisible--PLDmh";
export var animBarTypeA = "ReportPage-module--animBarTypeA--8Fh8f";
export var animBarTypeB = "ReportPage-module--animBarTypeB--3cytI";
export var animBarTypeC = "ReportPage-module--animBarTypeC--tWeva";
export var animBarTypeD = "ReportPage-module--animBarTypeD--3OpJP";